// Symbolic names for the `google.rpc.Code` values the grpc-gateway puts in its
// error envelope's numeric `code` field.
//
// One vocabulary, deliberately. The numeric code is the only stable
// discriminator the gateway gives us — several distinct refusals share one HTTP
// status, and the envelope's `message` is English prose a reword silently
// changes — but branching on bare integers at each call site spreads the
// mapping across files that then disagree. Callers get the name; this module
// owns the numbers.

const CODES = {
    1: "CANCELLED",
    2: "UNKNOWN",
    3: "INVALID_ARGUMENT",
    4: "DEADLINE_EXCEEDED",
    5: "NOT_FOUND",
    6: "ALREADY_EXISTS",
    7: "PERMISSION_DENIED",
    8: "RESOURCE_EXHAUSTED",
    9: "FAILED_PRECONDITION",
    10: "ABORTED",
    11: "OUT_OF_RANGE",
    12: "UNIMPLEMENTED",
    13: "INTERNAL",
    14: "UNAVAILABLE",
    15: "DATA_LOSS",
    16: "UNAUTHENTICATED",
};

/// Resolve a gateway `code` to its symbolic name.
///
/// Accepts the numeric form the envelope carries, and the string forms older
/// call sites pass (`"9"`, `"CODE_FAILED_PRECONDITION"`). An unrecognized
/// number stringifies rather than collapsing to a name that would lie; a
/// non-number, non-string yields `""`.
export function grpcStatusName(value) {
    if (typeof value === "number") return CODES[value] ?? String(value);
    if (typeof value !== "string") return "";
    if (CODES[Number(value)]) return CODES[Number(value)];
    return value.replace(/^CODE_/, "").toUpperCase();
}
